module.exports = __webpack_public_path__ + "img/partner_6.8580900.png";